'use strict';
module.exports = [
    function() {

        return {
            controller: ['$element', '$scope', yCheckboxCtrl],
            controllerAs: 'ctrl',
            template: `
            <md-checkbox
               ng-model="model"
               ng-change="ctrl.onChange()"
               aria-label="{{ rmLabel }}"
               ng-disabled="rmDisabled"
            ></md-checkbox>
            `,
            scope: {
                yModel: '=model',
                model: '=localModel',
                rmLabel: '@',
                rmDisabled: '='
            },
            restrict: 'E',
            link: function($scope, $element) {
            },
        };
    }];

class yCheckboxCtrl {
    constructor($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;

        this.yObserveHandler = this.yObserver.bind(this);
        $scope.yModel.observe(this.yObserveHandler);
        $scope.$on('$destroy', this.destroy.bind(this));

        this.setChecked($scope.yModel.toString());
    }

    yObserver(event) {
        if(event.type == 'insert') {
            this.setChecked(event.object.toString());
        }
    }

    onChange() {
        let length = this.$scope.yModel.toString().length;
        this.$scope.yModel.delete(0, length);

        let val = this.$scope.model;
        this.$scope.yModel.insert(0, val.toString());
    }

    toBool(val) {
        return val === 'true' || val === '1';
    }

    setChecked(val) {
        this.$scope.model = this.toBool(val);
    }

    destroy() {
        this.$scope.yModel.unobserve(this.yObserveHandler);
    }
}
